import React from 'react'
import Extra_1 from '../../../assets/images/home_page_4/affiliate/02.png'
import Extra_2 from '../../../assets/images/home_page_4/affiliate/03.png'
import Extra_3 from '../../../assets/images/home_page_4/affiliate/04.png'

const cards = [
    {
        image: Extra_1,
        title: 'Bluetooth Earphones',
        text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been cared.',
    },
    {
        image: Extra_2,
        title: 'Gaming Consoles',
        text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been cared.',
    },
    {
        image: Extra_3,
        title: 'Smartwatches',
        text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been cared.',
    },
];


const Extra = () => {
    return (
        <>
            <section id="extraordinary" className="extraordinary-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="extraordinary-block text-center">
                                <h6 className="affiliate-sub-heading">About US</h6>
                                <h1 className="affiliate-main-heading">
                                    Beyond the Ordinary, Career Extraordinary!
                                </h1>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {cards.map((card, index) => (
                            <div className="col-lg-4 col-md-4" key={index}>
                                <div className="card text-center">
                                    <div className="card-img">
                                        <img src={card.image} className="img-fluid" alt={card.title} />
                                    </div>
                                    <div className="card-dtls">
                                        <h3 className="card-title">{card.title}</h3>
                                        <p className="card-text">{card.text}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        </>
    )
}

export default Extra
